<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<lms-message-tab *ngIf="selectedTab?.subTypeDetail.notes?.message"  [message]="selectedTab?.subTypeDetail.notes.message"  (clearMessage)="clearErrorMessage($event)"></lms-message-tab>
    <lms-notes-header [subTypes]='subTypes' [addNoteText]='noteText' [tab]='selectedTab' [notesList]='loadData' [enableDeleteAll]='loadData && loadData.listOfNotes && loadData.listOfNotes.length > 0 ? true : false' (updateNotesList)='updateNotes($event)'
        (cancelEditNotes)='cancelNotes($event)' (deleteAllNote)='showDeletePopUp($event)'></lms-notes-header>
    <div *ngIf="selectedTab && selectedTab.subTypeDetail && selectedTab.subTypeDetail.notes?.status  == 'blank'" class="page-helper-text">
        {{blankMessage}}
    </div>
    <div *ngIf="selectedTab && selectedTab.subTypeDetail && selectedTab.subTypeDetail.notes?.status  == 'error'" class="page-helper-text color-red">
        {{errorMessage}}
    </div>
    <div class="clearfix"></div>
    <div class="note-page-ui" *ngIf="loadData && selectedTab && selectedTab.subTypeDetail && selectedTab.subTypeDetail.notes?.status  == 'loaded'">
        <p class="paging-numbers">Showing {{startPage}} to {{endPage}} of {{loadData?.listOfNotes.length}} records</p>
        <div class="add-note-box">
            <input type="text" id="addNoteTextBox" tabindex="{{tabLevel - 1}}" [disabled]="user && user.isUserManagerOrDirector?false:true" [(ngModel)]="noteText" placeholder="Add Notes" maxlength="62" (focus)='setEditModeForAdd()' (keyup)="setEditModeForAdd()" style="text-transform:uppercase"
                (blur)='removeFocusToAddUpdateBtn();' />
            <button id="notesAddUpdateBtn" tabindex="{{tabLevel}}" type="button" (click)="addNote()" class="{{ noteText && noteText.trim().length > 0 && (user && user.isUserManagerOrDirector)? 'p-button-primary' : 'p-button-disabled'}}" disabled="{{ noteText && noteText.trim().length > 0  && (user && user.isUserManagerOrDirector) ? '' : 'disabled'}}">Add/Update</button>
        </div>
        <div class="note-scrollable-area" [style.max-height.px]='height' #viewPortPaging=viewPortpaging lmsViewportPaging [child]="'added-notes'" (getPagingData)="getPagingdata($event)">
            <div class="added-notes" *ngFor="let note of loadData?.listOfNotes; let i = index;">
                <lms-notes-data [note]='note' [tabIndex]='tabLevel + (i + 1)' [index]='i' [tab]='selectedTab' (isEditForAdd)='isEditForAddEvent($event)' (deleteNote)='showDeletePopUp($event)'></lms-notes-data>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>

    <p-dialog transitionOptions="0ms" [baseZIndex]="1000" [resizable]="false" [closeOnEscape]='true' [draggable]="false" class="terminal-ui-popups standard-dialog" header="Confirmation" [(visible)]="showWarnPop" modal="true" (onShow)='setPageMode("confirmDialogButton");' (onHide)='setPageMode("");'>
        <div class="generic-spacing">
            {{warnMessage}}
        </div>

        <div class="dialog-buttons">

            <span class="pull-right">
				<button class="p-button-secondary" tabindex="{{tabLevelDialog}}" (click)="hideWarnPopup()">No</button>
					<button class="p-button-primary" tabindex="{{tabLevelDialog + 1}}" id='confirmDialogButton' (click)="continueDeleteAll()">Yes</button>
			</span>

        </div>
    </p-dialog>
